
import each from 'lodash/each'
import map from 'lodash/map'
// App Store
import { app } from './utils/store'

// User Detect
import { DetectionManager } from './utils/detect'

// Classes::Managers
import { ScrollManager } from './classes/Scroll'

import Form from './classes/Forms'

import Search from './modules/Search'
import Carousel from './modules/Carousel'
import Lightbox from './modules/Lightbox'

// Pages
import DesignSystem from './pages/DesignSystem'
import Home from './pages/Home'
import About from './pages/About'
import Architects from './pages/Architects'
import BookAppointment from './pages/BookAppointment'
import Collaborate from './pages/Collaborate'
import Services from './pages/Services'
import FormView from './pages/Form'
import Privacy from './pages/Privacy'
import Cookie from './pages/Cookie'

import ArchiveAccessory from './pages/Accessory'
import SingleAccessory from './pages/Accessory/single'

import ArchiveStore from './pages/Store/index.bak'
import SingleStore from './pages/Store/single'

import TaxonomyKind from './pages/Kinds'

import ArchiveInspiration from './pages/Inspiration'
import SingleInspiration from './pages/Inspiration/single'

import ArchiveRooms from './pages/Room/page'
import TaxonomyRoom from './pages/Room'
import TaxonomyRoomCucina from './pages/Room/cucina'

import ArchivePromo from './pages/Promo'
import SinglePromo from './pages/Promo/single'

import ArchiveProduct from './pages/Product'
import SingleProduct from './pages/Product/single'
import Contact from './pages/Contact'
import AfterSalesAppliances from './pages/AfterSalesAppliances'
import Faq from './pages/Faq'
import Furniture from './pages/Furniture'
import ProductWarranty from './pages/ProductWarranty'

import System from './pages/System/single'
import VirtualTour from './pages/VirtualTour'
import Magazine from './pages/Magazine'
import Contract from './pages/Contract'
import Tour from './pages/VirtualTour/tour'
import Reseller from './pages/Reseller'
import WhyFebalcasa from './pages/WhyFebalcasa'
import Libeskind022 from './pages/Libeskind022'
import StoresItaly from './pages/StoresItaly'
import Blog from './pages/Blog'
import SinglePost from './pages/Blog/single'
import ThankYou from './pages/ThankYou'
import SearchPage from './pages/Search'
import TotalLiving from './pages/TotalLiving'
import Easy10 from './pages/Easy10'
import Error404 from './pages/Error'
import CategoryBlog from './pages/Blog/category'

import LandingCollaboration from './pages/Landing/collaboration'
import LandingSalone from './pages/Landing/salone'

import OndaZHA from './landing/onda-zahahadid'

import ClustersPage from './pages/Clusters'

class Assets {
    constructor() {
        app.init = true
        app.bundle = true
        app.root = document.body
        app.viewport = document.querySelector('[data-app-viewport]')
        app.content = document.getElementById("app-content")

        app.create = {
            content: this.createContent.bind(this),
            pages: this.createPages.bind(this),
            scroll: this.createScroll.bind(this),
            carousels: this.createCarousels.bind(this),
            lightbox: this.createLightbox.bind(this),
            forms: this.createForms.bind(this),
        }

        map(app.create, (callback) => { return callback() })

        app.loading = false
    }

    // Create Content
    createContent = () => {
        this.template = app.root.getAttribute('data-template')
        this.content = document.querySelector('[data-app-content]')

        this.wrapper = document.querySelector('[data-wrapper]')
        this.navigation = document.querySelector('[data-app-viewport]')

        this.navigation = document.querySelector('[data-navigation-bar]')

        this.anchors = document.querySelectorAll('a[href^="#"]:not([href="#"])')

        this.accordion = { togglers: document.querySelectorAll('.accordion-button'), }
        this.dropdown = { togglers: document.querySelectorAll('[data-bs-toggle="dropdown"]'), }
        this.click = { togglers: document.querySelectorAll('[data-click-target]'), }
        this.modal = {
            elements: document.querySelectorAll('[data-modal]'),
            togglers: document.querySelectorAll('[data-modal-target]'),
            closers: document.querySelectorAll('[data-modal-close]')
        }

        this.forms = document.querySelectorAll('form')
        this.search = document.getElementById('global-search')

        this.carousels = document.querySelectorAll('[data-carousel]')
        this.finishes = document.querySelectorAll('ul.list--materials')

        app.current = this.template
        app.wrapper = this.wrapper
        app.viewport = this.viewport
        app.nav = this.navigation

        app.scroll = window
    }

    // Create Pages
    createPages = () => {
        this.pages = {
            designsystem: new DesignSystem(), // Temporary

            about: new About(),
            architects: new Architects(),
            book_appointment: new BookAppointment(),
            collaborate: new Collaborate(),
            magazine: new Magazine(),
            cookie: new Cookie(),
            home: new Home(),
            privacy: new Privacy(),
            services: new Services(),
            thank_you: new ThankYou(),
            tour: new Tour(),
            virtual_tour: new VirtualTour(),
            form: new FormView(),
            contract: new Contract(),
            reseller: new Reseller(),
            why_febalcasa: new WhyFebalcasa(),
            libeskind_022: new Libeskind022(),
            stores_italy: new StoresItaly(),
            search: new SearchPage(),
            total_living: new TotalLiving(),
            easy10: new Easy10(),
            error404: new Error404(),

            //contacts page
            contact: new Contact(),
            after_sales_appliances: new AfterSalesAppliances(),
            faq: new Faq(),
            furniture: new Furniture(),
            product_warranty: new ProductWarranty(),
            //Blog
            blog: new Blog(),
            single_post: new SinglePost(),
            category_blog: new CategoryBlog(),
            // Accessory
            archive_accessory: new ArchiveAccessory(),
            single_accessory: new SingleAccessory(),
            // Kind
            taxonomy_kind: new TaxonomyKind(),
            // Room
            archive_rooms: new ArchiveRooms(),
            taxonomy_room: new TaxonomyRoom(),
            taxonomy_room_cucina: new TaxonomyRoomCucina(),
            // Promo
            archive_promo: new ArchivePromo(),
            single_promo: new SinglePromo(),
            // Product
            archive_product: new ArchiveProduct(),
            single_product: new SingleProduct(),
            // Inspiration
            archive_inspiration: new ArchiveInspiration(),
            single_inspiration: new SingleInspiration(),
            // Store
            archive_store: new ArchiveStore(),
            single_store: new SingleStore(),
            // System
            single_system: new System(),

            // Landing
            landing_collaboration: new LandingCollaboration(),
            landing_salone: new LandingSalone(),

            landing_onda_zha: new OndaZHA(),

            // Clusters
            cluster_listing: new ClustersPage(),
        }

        this.page = this.pages[app.current]
        app.page = this.page

        if (app.page) {
            app.page.create()

            if(app.bundle && app.scroll){
                app.scroll.addEventListener('scroll', (event) => {
                    if (app.scroll == window) { app.scrollTop = window.scrollY }
                    else { app.scrollTop = app.scroll.scrollTop }
    
                    if (app.scrollTop > app.nav.clientHeight) {
                        app.nav.classList.add('navigation--active')
                    } else {
                        app.nav.classList.remove('navigation--active')
                    }
                })
            }
        }
    }

    // Create Forms
    createForms = () => {
        if (this.forms) {
            each(this.forms, (form) => { return new Form({ element: form }) })
        }

        if (this.search) {
            this.search = new Search()
        }
    }

    createCarousels = () => {
        if (this.carousels) {
            each(this.carousels, (carousel) => { return new Carousel({ element: carousel }) })
        }
    }

    createLightbox = () => {
        if (this.finishes) {
            each(this.finishes, (list) => { return new Lightbox({ element: list }) })
        }
    }

    // Create Scroll
    createScroll = () => {
        ScrollManager.onLoadAnchor()

        if (this.anchors) {
            this.anchors.forEach((link) => ScrollManager.scrollBehaviour(link))
        }
    }

    /*
    ** Events
    */
}

new Assets()